export default "__VITE_ASSET__BhyRNtf3__"